var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_clock",
    transform: "translate(-1.000000, 0.000000)",
    fill: "#697287",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8,11.6 C4.45321321,11.6040462 2.3352556,10.1934898 1.43437415,8.02650176 C0.533492686,5.85951371 1.02724469,3.36319188 2.68524361,1.7023294 C4.34324254,0.041466917 6.83870862,-0.456592061 9.00724803,0.440548649 C11.1757874,1.33768936 12.5899965,3.45320972 12.59,5.8 C12.5845162,8.99707695 9.99706273,11.5889993 6.8,11.6 L6.8,11.6 Z M6.8,1 C4.85767634,0.995953484 3.10435542,2.16286687 2.35825478,3.95617985 C1.61215415,5.74949282 2.02034976,7.81569645 3.39235008,9.19056107 C4.76435039,10.5654257 6.82969823,10.9779295 8.62456331,10.2355704 C10.4194284,9.49321138 11.5899958,7.74232788 11.59,5.8 C11.5900057,3.15293354 9.44706072,1.00551472 6.8,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.62 8.33 6.3 6 6.3 1.84 7.3 1.84 7.3 5.59 9.33 7.62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic_clock.a579d52e672de4c34523217b1afa1f84.svg";
export { ForwardRef as ReactComponent };